import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /documents */
export const documentsRoutes: RouteObject = {
  path: 'documents',
  handle: handle('documents'),
  lazy: () => import('./DocumentsPage').then((m) => ({ Component: m.DocumentsPage })),
};
